import { render } from "./skin.vue?vue&type=template&id=783ba5c8&scoped=true"
import script from "./skin.vue?vue&type=script&lang=js"
export * from "./skin.vue?vue&type=script&lang=js"

import "./skin.vue?vue&type=style&index=0&id=783ba5c8&scoped=true&lang=css"

import exportComponent from "/Users/cole/Desktop/중요/xz_opr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-783ba5c8"]])

export default __exports__